import type { FC, ReactNode } from 'react';
import { Box, CircularProgress as MuiCircularProgress, Typography } from '@mui/material';

interface CircularProgressProps {
  title?: string;
  children?: ReactNode;
}

const containerSx = {
  flex: 1,
  display: 'flex',
  gap: 2,
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 200,
} as const;

const CircularProgress: FC<CircularProgressProps> = ({ title, children }) => {
  return (
    <Box sx={containerSx}>
      <MuiCircularProgress />
      {title && <Typography sx={t => ({ fontSize: t.typography.body1.fontSize })}>{title}</Typography>}
      {children}
    </Box>
  );
};

export default CircularProgress;
